const STORAGE_KEY = 'rentall_search_params';

// Campos del slice `personalized` que forman la búsqueda (Donde, Cuando, Cuantos).
// Se persisten para que sobrevivan a una nueva pestaña / recarga.
// No se incluyen flags de UI (showMap, totalPrice, isOneTotalToggle, searchLocationStatus).
const PERSISTED_KEYS = [
  'location',
  'lat',
  'lng',
  'geography',
  'chosen',
  'geoType',
  'sw_lat',
  'sw_lng',
  'ne_lat',
  'ne_lng',
  'personCapacity',
  'startDate',
  'endDate',
];

function isBrowser() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

function pickSearchParams(source = {}) {
  const picked = {};
  PERSISTED_KEYS.forEach((key) => {
    const value = source?.[key];
    // Se guardan nulls explícitos para que "limpiar" también persista;
    // se omiten undefined para no pisar valores válidos al fusionar.
    if (value !== undefined) picked[key] = value;
  });
  return picked;
}

export function saveSearchParams(personalized = {}) {
  if (!isBrowser()) return;
  try {
    const picked = pickSearchParams(personalized);
    const hasValue = Object.values(picked).some((v) => v !== null && v !== '' && v !== undefined);
    if (!hasValue) {
      window.localStorage.removeItem(STORAGE_KEY);
      return;
    }
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(picked));
  } catch (e) {
    // localStorage lleno o bloqueado (privado): la búsqueda sigue funcionando en memoria.
  }
}

export function loadSearchParams() {
  if (!isBrowser()) return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return pickSearchParams(parsed);
  } catch (e) {
    return null;
  }
}

export function clearSearchParams() {
  if (!isBrowser()) return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // noop
  }
}

export const SEARCH_PERSIST_KEY = STORAGE_KEY;
export const SEARCH_PERSISTED_KEYS = PERSISTED_KEYS;
